import React from 'react'
import { Trans } from 'next-i18next'
import { Box, Text } from '@machobear/design-system'

import { ExclamationOctagon } from '@/components/icons'

const RentedBanner = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      marginBottom={{ mobile: 'small', tablet: 'gutter' }}
      marginX={{ mobile: 'small', tablet: 'large' }}
    >
      <Box
        style={{ width: '100%', maxWidth: '1280px' }}
        padding="small"
        paddingY="medium"
        background="criticalLight"
        width="full"
        maxWidth="xlarge"
        borderRadius="large"
        boxShadow="borderCriticalLight"
        marginX="small"
        display="flex"
        alignItems="center"
        gap="small"
      >
        <ExclamationOctagon width={20} />
        <Text tone="critical" size="small">
          <Trans i18nKey="listing:b.listing_details.rented.banner.text">
            This listing has been marked as rented and is no longer accepting
            applications.
          </Trans>
        </Text>
      </Box>
    </Box>
  )
}

export default RentedBanner
